var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ods-color-hue-slider",class:{ 'is-vertical': _vm.vertical }},[_c('div',{ref:"bar",staticClass:"ods-color-hue-slider__bar",on:{"click":_vm.handleClick}}),_c('div',{ref:"thumb",staticClass:"ods-color-hue-slider__thumb",style:({
         left: _vm.thumbLeft + 'px',
         top: _vm.thumbTop + 'px'
       })})])
}
var staticRenderFns = []

export { render, staticRenderFns }